export const SET_DEST_MARKET = "SET_DEST_MARKET";
export const FORCE_UPDATE = "FORCE_UPDATE";

export const setDestMarket = destMarket => ({
  type: SET_DEST_MARKET,
  destMarket
});

export const setForceUpdate = () => ({
  type: FORCE_UPDATE
});
